module.exports = function (n) {
  var t = n.baseFontSize,
      e = n.defaultLineHeight,
      r = n.rhythmHeight,
      i = n.capHeights,
      o = n.debug;

  function a(n, t, e) {
    void 0 === e && (e = "nearest");
    var r = Math.floor(n / t) * t;
    return "up" === e || "nearest" == e && 2 * (n - r) >= t ? r + t : r;
  }

  return void 0 === o && (o = !1), {
    theme: {
      rhythmHeight: r,
      setFontWithRhythm: function setFontWithRhythm(n, o, u) {
        var h = function (n, o, u) {
          void 0 === u && (u = e);
          var h = 16 * t,
              g = o * h,
              m = i[n] * g,
              f = r * h,
              d = a(u * g, f);
          return d < m && (d = a(m, f, "up")), d / h;
        }(n, o, u),
            g = function (n, e, r) {
          return void 0 === r && (r = t), (e - r * i[n]) / 2;
        }(n, h, o * t);

        return "\n          font-family: " + n + ";\n          font-size: " + o + "rem;\n          padding-top: " + g + "rem;\n          margin-bottom: -" + g + "rem;\n          line-height: " + h + "rem;\n        ";
      },
      rhythmSizing: function rhythmSizing(n) {
        return r * n;
      }
    },
    global: "\n      " + (o ? "\n        html {\n          background: linear-gradient(rgba(255, 0, 0, 0.15), rgba(255, 0, 0, 0.15) 1px, transparent 1px);\n          background-size: 1px " + r + "rem;\n        }\n      " : "") + "\n\n      /* Specify our global font size */\n      body {\n        font-size: " + 100 * t + "%;\n      }\n    "
  };
};